module.exports = __webpack_public_path__ + "img/077-jordan.04ded4db.svg";